import React from 'react'
import { Drawer, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paper: {
    background: theme.palette.background.default,
    height: '100%',
  },
}))

type Props = {
  children: React.ReactNode
  isOpen: boolean
  onClose: () => void
}

export function SystemContainerDrawer({
  children,
  isOpen,
  onClose,
}: Props): React.ReactElement {
  const classes = useStyles()

  return (
    <Drawer
      classes={{ paper: classes.paper }}
      anchor="bottom"
      open={isOpen}
      onClose={onClose}
    >
      {children}
    </Drawer>
  )
}
